module.exports = __webpack_public_path__ + "static/img/pat.0ae99e5c.webp";